import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الراتب اليومي - حساب اجر اليوم من الراتب الشهري";
const DESCRIPTION =
  "احسب راتبك اليومي بناءً على راتبك الشهري وعدد أيام العمل في الشهر. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة كم تكسب في اليوم الواحد.";
const KEYWORDS = "حاسبة, راتب, أجر, يومي, عمل, حساب, شهري";
const OG_URL =
  "https://do-calculate.com/calculator/ar/daily-salary-calculator/";
function DailySalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState("0");
  const [workDaysPerMonth, setWorkDaysPerMonth] = useState("0");
  const [dailyRate, setDailyRate] = useState(null);
  const [error, setError] = useState("");
  const calculateDailyRate = () => {
    try {
      if (monthlySalary === "0" && workDaysPerMonth === "0") {
        setError("الرجاء إدخال راتب وعدد أيام عمل صحيحة لحساب الراتب اليومي");
        return;
      }
      const dailyWage = monthlySalary / workDaysPerMonth;
      setDailyRate(dailyWage);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة سهلة لمعرفة الراتب الذي تكسبه في اليوم
                  بناءً على راتبك الشهري وعدد أيام العمل في الشهر. معرفة الراتب
                  اليومي أمر مهم لفهم قيمة يوم عملك بشكل أفضل، سواء كنت تفكر في
                  التفاوض على راتبك أو تخطط لأعمال إضافية. هذه الحاسبة مفيدة
                  للأشخاص الذين يعملون برواتب شهرية ويرغبون في معرفة كيف يمكن أن
                  يتوزع دخلهم على أيام العمل في الشهر.
                </p>
                <p>
                  على سبيل المثال، إذا كنت تتقاضى راتبًا شهريًا قدره 6000 وتعمل
                  22 يومًا في الشهر، يمكنك استخدام هذه الحاسبة لتحديد كم تكسب في
                  اليوم. إن معرفة هذه التفاصيل قد يساعدك في اتخاذ قرارات مالية
                  أكثر حكمة وفي التفاوض على أجور أفضل بناءً على قيمة وقتك
                  الحقيقي.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="salary">الراتب الشهري:</label>
                    <input
                      id="salary"
                      type="number"
                      value={monthlySalary}
                      onChange={(e) => setMonthlySalary(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="work-days">عدد أيام العمل في الشهر:</label>
                    <input
                      id="work-days"
                      type="number"
                      value={workDaysPerMonth}
                      onChange={(e) => setWorkDaysPerMonth(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateDailyRate}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  dailyRate !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>الراتب اليومي: {dailyRate.toFixed(2)}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية حساب الراتب اليومي</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد الراتب الشهري
                    </h2>
                  </u>
                  <p>
                    في البداية، تحتاج إلى معرفة الراتب الشهري الذي تتقاضاه. يجب
                    أن يشمل هذا الراتب جميع المزايا والبدلات التي تحصل عليها
                    شهريًا. إدخال الراتب الشهري بدقة هو الخطوة الأولى نحو حساب
                    الراتب اليومي بشكل صحيح. تذكر أن الراتب الشهري هو الأساس
                    الذي ستبني عليه الحسابات التالية.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: تحديد عدد أيام العمل في الشهر
                    </h2>
                  </u>
                  <p>
                    بعد تحديد الراتب الشهري، يجب عليك إدخال عدد أيام العمل في
                    الشهر. هذا العدد يمثل الأيام التي تعمل فيها خلال الشهر والتي
                    تحصل فيها على راتبك. يمكن أن يختلف عدد أيام العمل من شهر
                    لآخر، ولكن يفضل إدخال العدد المتوسط للأيام التي تعملها
                    شهريًا. هذه المعلومة ضرورية لحساب الراتب اليومي بشكل دقيق.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب الراتب اليومي
                    </h2>
                  </u>
                  <p>
                    بعد إدخال الراتب الشهري وعدد أيام العمل في الشهر، يمكنك الآن
                    حساب الراتب اليومي. للقيام بذلك، قم بتقسيم الراتب الشهري على
                    عدد أيام العمل في الشهر للحصول على الراتب اليومي. هذه
                    العملية الحسابية ستمنحك القيمة الدقيقة للراتب الذي تكسبه في
                    اليوم الواحد.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان راتبك الشهري 6000 وعدد أيام العمل في الشهر 22
                    يومًا، فإن الراتب اليومي سيكون حوالي 272.73.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: استخدام الراتب اليومي في التخطيط المالي
                    </h2>
                  </u>
                  <p>
                    بعد معرفة الراتب اليومي، يمكنك استخدام هذه المعلومة في
                    تخطيطك المالي. على سبيل المثال، إذا كنت تفكر في العمل أيام
                    إضافية أو تحتاج إلى معرفة ما إذا كان راتبك اليومي يكفي
                    لتغطية نفقاتك، فإن معرفة الراتب اليومي يساعدك في اتخاذ
                    قرارات مستنيرة. كما يمكن أن يساعدك هذا الحساب في التفاوض على
                    راتب أفضل بناءً على قيمة يوم عملك.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كنت تخطط للعمل 5 أيام إضافية في الشهر، يمكنك حساب
                    مقدار الراتب الإضافي الذي ستجنيه بناءً على الراتب اليومي.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DailySalaryCalculator;
